<template>
  <div class="commodity">

    <div class="feature-container">
      <el-form :inline="true" :model="searchform" class="search-form" label-width="150px">
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="商品号：">
              <el-input v-model="searchform.commodityId" placeholder="商品号" size="medium"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="商品名称：">
              <el-input v-model="searchform.commodityName" placeholder="商品名称" size="medium"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:30px">
            <el-form-item>
              <el-button type="primary" @click="search" size="medium">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div class="list-container">
      <el-table :data="commodityList" ref="multiple" border="" height="700">
        <el-table-column prop="commodityId" label="商品号" width="80"></el-table-column>
        <el-table-column prop="commodityName" label="商品名称"></el-table-column>
        <el-table-column prop="appName" label="app名称"></el-table-column>
        <el-table-column prop="description" label="商品描述"></el-table-column>
        <el-table-column prop="content" label="授权信息"></el-table-column>
        <el-table-column prop="price" label="价格"></el-table-column>
        <el-table-column prop="indate" label="有效期"></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click.native.prevent="edit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click.native.prevent="deleteRow(scope.$index, scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="commodityTable.currentPage" :page-sizes="commodityTable.pageSizes" :page-size="commodityTable.pageSize" layout="total, prev, pager, next, sizes, jumper" :total="commodityTable.total"></el-pagination>
    </div>

    <el-dialog title="编辑商品信息" :visible.sync="visible.updateDialogVisible" width="26%">

      <el-form label-position="left" :model="selectRow" label-width="100px" :rules="validateCommodity" ref="UpdateForm">
        <el-form-item label="商品号" prop="commodityId">
          <el-input v-model="selectRow.commodityId" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="commodityName">
          <el-input v-model="selectRow.commodityName"></el-input>
        </el-form-item>
        <el-form-item label="app名称" prop="appName">
          <el-input v-model="selectRow.appName"></el-input>
        </el-form-item>
        <el-form-item label="商品描述" prop="description">
          <el-input v-model="selectRow.description"></el-input>
        </el-form-item>
        <el-form-item label="授权信息" prop="content">
          <el-input v-model="selectRow.content"></el-input>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input v-model="selectRow.price"></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="indate">
          <el-input v-model.number="selectRow.indate"><template slot="append">分钟</template></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible.updateDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateCommodity">确定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>

</template>

<script>

export default {
  name: 'commodity',
  data () {
    return {
      searchform: {
      },
      commodityList: [],
      commodityTable: {
        total: 0,
        pageSizes: [10, 20, 50],
        pageSize: 20,
        currentPage: 1
      },
      visible: {
        createDialogVisible: false,
        updateDialogVisible: false
      },
      validateCommodity: {
        appName: [{
          required: true, message: '请输入app名称'
        }],
        commodityName: [{
          required: true, message: '请输入商品名称'
        }],
        price: [{
          required: true, message: '请输入价格'
        }],
        indate: [{
          required: true, message: '请输入有效期'
        }, {
          type: 'number', message: '请输入数字'
        }]
      },
      selectRow: {
      }
    }
  },
  created: async function () {
    var data = {}
    data.page = this.commodityTable.currentPage
    data.size = this.commodityTable.pageSize
    var res = await this.$$getCommodityList(data)
    this.commodityList = res.list
    this.commodityTable.total = res.total
  },
  methods: {
    search () {
      if (Object.keys(this.searchform).length === 0) {
        this.$message.error('关键字不能为空')
        return
      }
      this.commodityTable.currentPage = 1
      this.refreshList()
    },
    refreshList: async function () {
      this.searchform.page = this.commodityTable.currentPage
      this.searchform.size = this.commodityTable.pageSize
      var res = await this.$$getCommodityList(this.searchform)
      this.commodityTable.total = res.total
      this.commodityList = res.list
    },
    /**
         * 分页操作
         */
    handleSizeChange (val) {
      this.commodityTable.pageSize = val
      this.refreshList()
    },
    handlePageChange (val) {
      this.commodityTable.currentPage = val
      this.refreshList()
    },

    edit (index, row) {
      this.selectRow = JSON.parse(JSON.stringify(row))
      this.visible.updateDialogVisible = true
    },
    updateCommodity () {
      this.$refs.UpdateForm.validate(async valid => {
        if (valid) {
          // delete this.selectRow.commodityId;
          // var res = await this.$$postCommodity(this.selectRow);
          var res = await this.$$updateCommodity(this.selectRow)
          if (res) {
            this.refreshList()
            this.visible.updateDialogVisible = false
          }
        }
      })
    },
    deleteRow (index, row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$$deleteCommodity(row.commodityId).then(() => {
          this.$message.success('删除成功！')
          this.refreshList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.commodity {
    /* height: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: rgb(240,242,245); */
}
.feature-container {
    margin: 20px;
    background-color: #ffffff;
}
.list-container {
    margin: 20px;
}
</style>
